var map = {
	"./da-DK.json": [
		85965,
		5965
	],
	"./de-DE.json": [
		71219,
		1219
	],
	"./el-GR.json": [
		95671,
		5671
	],
	"./en-GB.json": [
		86573,
		6573
	],
	"./en-MY.json": [
		11290,
		1290
	],
	"./en-US.json": [
		70872,
		872
	],
	"./es-ES.json": [
		88357,
		8357
	],
	"./fa-IR.json": [
		82425,
		2425
	],
	"./fi-FI.json": [
		12235,
		2235
	],
	"./fr-FR.json": [
		70085,
		85
	],
	"./hr-HR.json": [
		96469,
		6469
	],
	"./it-IT.json": [
		94443,
		4443
	],
	"./ko-KR.json": [
		82898,
		2898
	],
	"./lt-LT.json": [
		75769,
		5769
	],
	"./nb-NO.json": [
		42910,
		2910
	],
	"./pl-PL.json": [
		74081,
		4081
	],
	"./ro-RO.json": [
		49675,
		9675
	],
	"./sv-SE.json": [
		22378,
		2378
	],
	"./tr-TR.json": [
		28613,
		8613
	],
	"./vi-VN.json": [
		10102,
		102
	],
	"./zh-SG.json": [
		95485,
		5485
	],
	"./zh-TW.json": [
		98718,
		8718
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 40125;
module.exports = webpackAsyncContext;